export default __webpack_public_path__ + "static/font-cb68b46ce9390874acdd27212d8f325a.woff";